import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useAuth } from '../auth/authContext';
import { useNavigate } from 'react-router-dom';
export const Login = () => {
    const { login, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard', { replace: true });
        }
    }, [isAuthenticated, navigate]);
    return (_jsx("div", { style: styles.container, children: _jsxs("div", { style: styles.card, children: [_jsx("h1", { style: styles.title, children: "Sign In" }), _jsx("p", { style: styles.subtitle, children: "Access your Glazier account" }), _jsx("button", { onClick: login, style: styles.button, children: "Sign In with Cognito" }), _jsxs("p", { style: styles.footer, children: ["Or go back to ", _jsx("a", { href: "/", style: styles.link, children: "home" })] })] }) }));
};
const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0071e3 0%, #0077ed 50%, #54b0fd 100%)',
        padding: '20px',
    },
    card: {
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        backdropFilter: 'blur(30px)',
        WebkitBackdropFilter: 'blur(30px)',
        borderRadius: '20px',
        padding: '48px',
        border: '1px solid rgba(255, 255, 255, 0.8)',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
        maxWidth: '400px',
        width: '100%',
    },
    title: {
        margin: '0 0 8px 0',
        fontSize: '32px',
        fontWeight: '700',
        color: '#1d1d1f',
        letterSpacing: '-0.5px',
    },
    subtitle: {
        margin: '0 0 40px 0',
        fontSize: '16px',
        color: '#86868b',
        fontWeight: '400',
    },
    button: {
        width: '100%',
        padding: '14px 16px',
        backgroundColor: '#0071e3',
        color: 'white',
        border: 'none',
        borderRadius: '12px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 10px 30px rgba(0, 113, 227, 0.3)',
    },
    footer: {
        marginTop: '32px',
        fontSize: '14px',
        color: '#86868b',
        textAlign: 'center',
        fontWeight: '400',
    },
    link: {
        color: '#0071e3',
        textDecoration: 'none',
        fontWeight: '600',
    },
};
//# sourceMappingURL=Login.js.map